module.exports = __webpack_public_path__ + "img/DSC_7083.5784dab5.jpg";